import React from 'react';
import { StyleSheet, css } from 'aphrodite'

import PortfolioItem from '../../Utilities/PortfolioItem'
import BlockChain from './BlockChain'
import SkewBg from './SkewBg'
//Images
import ImgCryptoWorldCup from '../../../assets/portfolio/BlockChain/CryptoWorldCup.png'
import ImgAragonTerminal from '../../../assets/portfolio/BlockChain/AragonTerminal.png'




export default class IndexAppBlockChain extends React.Component{
 render(){
  return(
    <section id="BlockChain" className="MainContainer" className={css(styles.MainContainer)}>
    <SkewBg />
     <div className={css(styles.MainDiv)}>
     <BlockChain />
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="220px" rowDirection="row-reverse" alignText="left" alignImg="center" img={ImgCryptoWorldCup} title="Crypto World Cup" subtitle="Ethereum Betting Platform" text="http://www.cryptoworldcup.io"/>
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="250px" rowDirection="" alignText="right" alignImg="center" img={ImgAragonTerminal} title="Bouncer_dao" subtitle="Decentralized Access Control for DAO" text="https://www.github.com/dev_nacho/bouncer_dao"/>
     </div>
    </section>
  );
 }
}

const styles = StyleSheet.create({
  MainContainer: {
    position: 'relative',
  },
	MainDiv : {
    paddingTop: '18em',
		margin: '0 auto',
    maxWidth: 850,
   '@media (max-width: 768px)' :{
      textAlign: 'center',
      paddingTop: '8em',
   }
	}
})


// WEBPACK FOOTER //
// ./src/Components/Portfolio/BlockChain/IndexBlockChain.js